import React from "react";
var useFallbackRef = function useFallbackRef(givenRef, initialValue) {
  var fallbackRef = React.useRef(initialValue);
  if (givenRef) {
    return givenRef;
  }
  return fallbackRef;
};
export default useFallbackRef;